import styled, { css } from 'styled-components';
import Text from '@components/text';

export const Container = styled.div``;

export const StyledTitle = styled(Text)`
  ${({ theme }) => css`
    text-align: center;

    @media only screen and (max-width: ${theme.breakpoints.sm}) {
      text-align: left;
    }
  `}
`;
